import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {ICON_PROPERTIES_BY_SIZE, IconSizeType} from 'common/constants';
import {isURL} from 'common/util/url';

import {template} from './template';
import css from './index.styl?inline';
import {getDefaultIconUrl, getGravatarUrl} from './utils';

export class TrackedUserIcon extends Component<EmptyObj> {
  static get attrsSchema() {
    return {
      'img-src': {
        type: `string`,
        description: `If it is present, is used as the icon image. Usually used with $avatar param`,
      },
      'distinct-id': `string`,
      email: `string`,
      'disable-tooltip': `boolean`,
      size: {type: `string`, default: IconSizeType.Medium, enum: Object.values(IconSizeType)},
      'tooltip-text': `string`,
      'tooltip-placement': {type: `string`, default: `top`},
    };
  }

  get config() {
    return {
      template,
      css,
      useShadowDom: true,
      helpers: {
        getIconProperties: () => this.getIconProperties(),
        getAvatarSrc: () => {
          const email = this.attr(`email`);
          const imgSrc = this.attr(`img-src`);
          const {imgSize} = this.getIconProperties();
          const defaultIcon = getDefaultIconUrl(this.attr(`distinct-id`), imgSize);

          if (isURL(imgSrc)) {
            return getGravatarUrl(email, imgSize, imgSrc, true);
          }

          if (!email) {
            return defaultIcon;
          }
          return getGravatarUrl(email, imgSize, defaultIcon);
        },
        isTooltipEnabled: () => {
          return !this.attr(`disable-tooltip`) && this.attr(`tooltip-text`);
        },
      },
    };
  }

  getIconProperties() {
    return ICON_PROPERTIES_BY_SIZE[this.attr(`size`)];
  }
}

export const TrackedUserIconEl = defineAndMakeJsxFactory(`mp-tracked-user-icon`, TrackedUserIcon);
